import React from "react";
import RefundRequestList from "../../components/Pages/RefundRequests/List/List";

const RefundRequests = () => {
  return (
    <div>
      <RefundRequestList />
    </div>
  );
};

export default RefundRequests;
